module.exports = __webpack_public_path__ + "img/LogoBrancoHorizontal.b2a2b951.png";